import TemperatureInsight from "./TemperatureInsight";

export default class ColdestDay extends TemperatureInsight {
  temperatureType(): string {
    return 'coldest';
  }
}
